export const commonEn = {
  "Close dialog": "Close dialog",
  "site title": "EasyBar",
  "Manage Users": "Manage Users",
  "Manage Steel Types": "Manage Steel Types",
  "Manage Diameter and Weight": "Manage Diameter and Weight",
  "Logout": "Logout",
  "Add a drawing": "Add a drawing",
  "Please enter values ": "Please enter values ",
  "Bar Number": "Bar Number",
  "Steel diameter": "Steel diameter",
  "Angled": "Angled",
  "Weight one bar": "Weight one bar",
  "total weight": "total weight",
  "notes": "notes",
  "Bars": "Bars",
  "Edit": "Edit",
  "Remove": "Remove",
  "select a business first to edit": "select a business first to edit",
  "Company Added SuccessFully": "Company Added SuccessFully",
  "approval not checked": "approval not checked",
  "Business Details": "Business Details",
  "Please Select Business": "Please Select Business",
  "business details show automatically": "business details show automatically",
  "Edit business": "Edit business",
  "add a business": "add a business",
  "fill the window will create business card": "fill the window will create business card",
  "Business": "Business",
  "Company Manager": "Company Manager",
  "Manager": "Manager",
  "Email": "Email",
  "confirm that I work for this company": "confirm that I work for this company",
  "Approval of regulations": "Approval of regulations",
  "Add business": "Add business",
  "Edit Company": "Edit Company",
  "fill the window will update Company": "fill the window will update Company",
  "Diameter and Weight Added SuccessFully": "Diameter and Weight Added SuccessFully",
  "Are you sure you wish to delete this Diameter and Weight?": "Are you sure you wish to delete this Diameter and Weight?",
  "Diameters And Weights": "Diameters And Weights",
  "Add new Diameter with Weight": "Add new Diameter with Weight",
  "Diameter": "Diameter",
  "Weight": "Weight",
  "Add Diameter and Weight": "Add Diameter and Weight",
  "fill the window will create new Diameter with Weight": "fill the window will create new Diameter with Weight",
  "Add Diameter": "Add Diameter",
  "Edit Diameter and Weight": "Edit Diameter and Weight",
  "fill the window will update Diameter with Weight": "fill the window will update Diameter with Weight",
  "Edit Diameter": "Edit Diameter",
  "Are you sure you wish to delete this item?": "Are you sure you wish to delete this item?",
  "Document Updated SuccessFully": "Document Updated SuccessFully",
  "Document Added SuccessFully": "Document Added SuccessFully",
  "Please select business and site": "Please select business and site",
  "Create Document": "Create Document",
  "Document Number": "Document Number",
  "Order Details": "Order Details",
  "Order Date": "Order Date",
  "Create Date": "Create Date",
  "Add item": "Add item",
  "Signature": "Signature",
  "Document": "Document",
  "Update": "Update",
  "Documents": "Documents",
  "Add new Document": "Add new Document",
  "date": "date",
  "The site": "The site",
  "contact": "contact",
  "Share": "Share",
  "Grid Number": "Grid Number",
  "Weight one net": "Weight one net",
  "step": "step",
  "Grids": "Grids",
  "Log In": "Log In",
  "Password": "Password",
  "horizontal": "horizontal",
  "vertical": "vertical",
  "spiral": "spiral",
  "Picket Number": "Pile number",
  "Weight One Picket": "Unit pile weight",
  "Quantity": "Quantity",
  "picket diameter": "Pile diameter",
  "spiral diameter": "spiral diameter",
  "total length": "total length",
  "spiral section 1": "spiral section 1",
  "spiral section 2": "spiral section 2",
  "spiral section end": "spiral section end",
  "space": "space",
  "total rounds": "total rounds",
  "Pickets": "Piles",
  "preview": "preview",
  "Preview Document": "Preview Document",
  "fill the window will show document preview": "fill the window will show document preview",
  "please correct the errors first": "please correct the errors first",
  "update item": "update item",
  "add item": "add item",
  "fill the window will update item": "fill the window will update item",
  "fill the window will create new item": "fill the window will create new item",
  "Choosen Element": "Selected element",
  "Choose Element": "Choose Element",
  "grid": "grid",
  "bars": "bars",
  "pickets": "piles",
  "Choosen Shape": "Selected shape",
  "Choose Shape": "Choose Shape",
  "line": "line",
  "turn": "turn",
  "return": "return",
  "dn": "DN",
  "hoop": "hoop",
  "longstr": "Long straight",
  "figure": "figure",
  "Update item": "Update item",
  "Add Item": "Add Item",
  "Email Added SuccessFully": "Email Added SuccessFully",
  "reload to get link": "reload to get link",
  "Confirmation not checked": "Confirmation not checked",
  "Are you sure you wish to remove this email?": "Are you sure you wish to remove this email?",
  "sent Documents": "sent Documents",
  "fill the window will share document with emails": "fill the window will share document with emails",
  "Add Email To share document": "Add Email To share document",
  "I allow this email to edit document": "I allow this email to edit document",
  "Add Email": "Add Email",
  "Link": "Link",
  "select a building Site first to edit": "select a building Site first to edit",
  "Building site Added SuccessFully": "Building site Added SuccessFully",
  "Business Site Details": "Business Site Details",
  "Site Name": "Site Name",
  "Please Select Site": "Please Select Site",
  "site details show automatically": "site details show automatically",
  "Edit site": "Edit site",
  "add building site": "add building site",
  "fill the window will create new building site": "fill the window will create new building site",
  "The Site": "The Site",
  "street": "street",
  "Note": "Note",
  "Manager Site Details": "Manager Site Details",
  "Contact for Field Coordination": "Contact for Field Coordination",
  "i confirm that details are correct": "i confirm that details are correct",
  "Edit Building site": "Edit Building site",
  "fill the window will update Building site": "fill the window will update Building site",
  "Edit building site": "Edit building site",
  "Steel Type Added SuccessFully": "Steel Type Added SuccessFully",
  "Are you sure you wish to delete this Steel Type?": "Are you sure you wish to delete this Steel Type?",
  "Steel Types": "Steel Types",
  "Add new Steel Type": "Add new Steel Type",
  "Add Steel Type": "Add Steel Type",
  "fill the window will create new Steel Type": "fill the window will create new Steel Type",
  "Edit Steel Type": "Edit Steel Type",
  "fill the window will update Steel Type": "fill the window will update Steel Type",
  "User Added SuccessFully": "User Added SuccessFully",
  "Are you sure you wish to delete this User?": "Are you sure you wish to delete this User?",
  "Users": "Users",
  "Add new User": "Add new User",
  "Admin": "Admin",
  "Add User": "Add User",
  "fill the window will create new User": "fill the window will create new User",
  "Edit User": "Edit User",
  "fill the window will update User": "fill the window will update User",
  "Creator Job": "Creator Job",
  "Actions": "Actions",
  "Select record": "Select record",
  "No records found": "No records found",
  "Ascending": "Ascending",
  "Descending": "Descending",
  "Default order": "Default order",
  "Sort by": "Sort by",
  "admin panel": "Admin Panel",
  "admin navigation": "Admin navigation",
  "admin open navigation": "Open admin navigation",
  "admin close navigation": "Close navigation",
  "admin application": "Application",
  "admin catalog": "Catalog",
  "admin activity": "Activity",
  "admin business": "Business",
  "admin shapes": "Shapes Pool",
  "admin steel": "Steel Types",
  "admin analytics": "User Analytics",
  "admin live users": "Live Users",
  "admin tickets": "Supplier Tickets",
  "admin bids": "Bids Calculator",
  "Delivery Date": "Delivery Date",
  "Phone": "Phone",
  "Address": "Address",
  "Number": "Number",
  "Mail": "Mail",
  "Site Man": "Site Man",
  "User": "User",
  "Rebars": "Rebars",
  "Nets": "Nets",
  "Cages": "Cages",
  "Rebar": "Rebar",
  "Net": "Net",
  "Cage": "Cage",
  "type": "type",
  "diameter": "diameter",
  "length": "length",
  "height": "Height",
  "Amount": "Amount",
  "total": "total",
  "weight": "weight",
  "unit": "unit",
  "units": "units",
  "Price": "Price",
  "Step": "Step",
  "Standard": "Standard",
  "Special": "Special",
  "Save": "Save",
  "Print": "Print",
  "Delete": "Delete",
  "cancel": "cancel",
  "submit": "Submit",
  "required field": "Required field",
  "Full name": "full name",
  "Job": 'Job',
  "Name": "name",
  "City": "city",

  "sides": "Sides",
  "name": "Name",
  "mobileVersionHiddenForNow":"Mobile version is on her way, meanwhile you can see us on desktop.",

  "quantity": "Quantity",

  "user details": "user details",

  "type password": "Type your password",
  "type phone number": "Type your phone number",
  "type job": "Type your job",
  "type full name": "Type your full name",
  "type email": "Type your email",
  "row": "Row",
  "download": "Download",
  "Preview": "Preview",

  'forget pass': 'Forget Password?',

  'email send': 'An email has been sent on',
  'email check': 'Please check your email',

  "dont delete": "Cancel",
  "confirm delete": "Delete Order",
  "email sent": "Email Sent",
  "welcome": "Welcome",
  "ok": "OK",
  "share": "Share",
  "note": "Note",
  "edit": "Edit",
  "sure": "sure",
  "weight unit": "Weight (kg)",
  "custom": "custom",
  "gap": "gap",
  "steel type": "steel type",
  "details": "Details",

  "download pdf": "download PDF",
  "send to supplier": "send to supplier",
  "print tickets": "print tickets",
  "delete order": "delete order",
  "send msg": "send message",

  //translations
  "thank": "thank you",
  "bid":"get bid",
  "Bid":"Get bid",
  "not now":"not now",
  "request":"The request was accepted. The best offer will be send to your WhatsApp.",
  "placeholder":"you can write delivery needs, extra needs, or anything we need to know for give you the right offer.",
  "bid question" : "would you like to get bid?",
  
  "confirm": "confirm",
  "Steel type": "Steel Type",
  "add": "Add",
  "update": "Update",

  "lengths": "lengths",
  "angles": "angles",
  "shapes": "shapes",
  "rebar name" : "rebar name",
  "symmetric": "Symmetrical",
  "asymmetric": "Asymmetrical",

  "extras" : "extras",
  "edge" : "edge",
  "base": "base",
  "side": "side",
  "ears": "ears",
  "rings": "rings",
  "gamma pipes": "gamma pipes",
  "cardinal": "cardinal",
  "internal": "internal",
  "amount": "amount",

  "diam": "diam",
  "qunt": "qunt",
  "radius": "radius",
};